export const LoaderStatus = {
    'Downloading': 0,
    'Processing': 1,
    'Done': 2
};
